import React, { useEffect } from 'react';
import { logCaseVisit } from '../../services/api';

const Ecology1 = () => {
  useEffect(() => {
    logCaseVisit('GAZ_ANALYZER').catch((error) => {
      console.error('Не удалось залогировать посещение кейса GAZ_ANALYZER', error);
    });
  }, []);

  return (
      <iframe
          src="https://iframe.digitalatyrau.kz/ecology"
          title="ecology"
          style={{ border: 'none' }}
          width="100%"
          height="149%"
      />
  );
};

export default Ecology1;